import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import 'rxjs/add/operator/toPromise';
import { ConnectivityChecker } from './connectivity.service';
import { MessagePresenter } from './message.service';
import { LocalStorageService } from './localStorage.service';
import { TranslateService } from '@ngx-translate/core';
import { App, ModalController } from 'ionic-angular';
import { FeatureFlags } from './featureFlags';
import { environment } from '../app/app.module';
import { CacheService } from 'ionic-cache';
import * as firebase from 'firebase';

@Injectable()
export class API {
  private readonly BASEURL = Object.freeze({
    S2: 'https://fuifi.s2grupo.es',
    DEV: 'https://dev.fuifi.com',
    PRO: 'https://api.fuifi.com',
    DEVLABERIT: ' https://dev.laberitapp.com', // Todo: esta dirección es temporal la buena es esta: https://dev.laberitapp.com
    PROCOLEVISA: 'https://panelcolevisa.fuifi.com',
    LABERIT: 'https://laberitapp.com',
    STARTUPV: 'https://apiupv.fuifi.com',
    LOCAL: 'http://fuifi.local',
    WEBDEV: 'https://dev.deggdavuzmyaz.amplifyapp.com/',
    WEBPRO: 'https://web.fuifi.com/',
    WEBLOCAL: 'localhost:8100', // con livereload para web
    WEBLOCAL2: 'localhost:8000', // sin livereload para web
  });

  private readonly PROXYENUM = Object.freeze({ // TODO: mover a los ficheros de environment?
    DEV: '/proxyDev/',
    PRO: '/proxyPro/',
    PROCOLEVISA: '/proxyProColevisa/',
  });

  private readonly apiVersion = '/api/v1/';
  private baseUrlDefault: any = this.BASEURL.LABERIT;
  private baseUrlAPIWithVersion = this.baseUrlDefault + this.apiVersion;
  private baseUrlAPINoVersion = this.baseUrlDefault; // se usa en searchDirectory() y se usa además en olvidé organización y recordar contraseña
  public baseWebUrl:any = this.BASEURL.WEBPRO; // se usa para saber si es app o no
  public baseWebLocal = this.BASEURL.WEBLOCAL2; // esto  confirma si es webapp o no cuando hacemos pruebas en local
  private proxy:any = this.PROXYENUM.PRO;
  private readonly isProxy: boolean = false; // true to proxy --l --c

  private readonly urlSolicitarDemo = 'https://fuifi.com/solicitar-demo-fuifi-organizacion/';

  constructor(private readonly http: HttpClient,
              private readonly connectivityService: ConnectivityChecker,
              private readonly messagePresenter: MessagePresenter,
              private readonly localStorage: LocalStorageService,
              private readonly translate: TranslateService,
              private readonly app: App,
              private readonly modalCtrl: ModalController,
              private readonly ftFlags: FeatureFlags,
              private readonly cache: CacheService,
            ) {

    this.changeEnvironmentApi(environment.toString());
  }

  private changeEnvironmentApi(env) {
    switch (env) {
      case 'fuifi':
        this.baseUrlDefault = this.BASEURL.PRO;
        this.baseWebUrl = this.BASEURL.WEBPRO;
      case 'startupv':
        this.baseUrlDefault = this.BASEURL.PRO;
        this.proxy = this.PROXYENUM.PRO;
        break;
      case 'laberit': // Todo: Pendiente de cambiar a url base cuando esté disponible por parte de backend
        this.baseUrlDefault = this.BASEURL.LABERIT;
        this.baseWebUrl = this.BASEURL.LABERIT;
        break;
      case 'fuifidev':
        this.baseUrlDefault = this.BASEURL.DEV;
        this.proxy = this.PROXYENUM.DEV;
        this.baseWebUrl = this.BASEURL.WEBDEV;
        break;
      case 'laberitdev': // Todo: pendiente de cambiar url base cuando esté disponible por parte de backend
        this.baseUrlDefault = this.BASEURL.DEVLABERIT;
        this.proxy = this.PROXYENUM.DEV;
        this.baseWebUrl = this.BASEURL.DEVLABERIT;
        break;
      case 'colevisaempresas':
      case 'soycolevisa':
        this.baseUrlDefault = this.BASEURL.PROCOLEVISA;
        this.proxy = this.PROXYENUM.PROCOLEVISA;
        break;
    }
    this.resetBaseUrlAPI();
  }

  public getForgotOrganizationLink() {
    // return `${this.baseUrlDefault}/remember-organization`;
    return `${this.baseUrlAPINoVersion}/remember-organization`; // Todo: se actualiza la urlbase según el team con método updateUrlBaseAPI() según el team
  }

  public getResetPassLink() {
    // return `${this.baseUrlDefault}/password/reset`;
    return `${this.baseUrlAPINoVersion}/password/reset`; // Todo: se actualiza la url base según el team
  }

  public getSolicitarDemoLink() {
    return this.urlSolicitarDemo;
  }

  /* Actualiza urlBase.
   * Este método solo debería invocarse después de que el user indique su Organización en el Login.
   */
  public updateUrlBaseAPI(url) {
    if (url != null && url !== '') {
      this.baseUrlAPIWithVersion = url + this.apiVersion;
      this.baseUrlAPINoVersion = url; /// Todo: el enlace de recuperar contraseña y olvidé organización ya utilizan esta base y funcionan, revisar con Paco si se debe utilizar en todas las llamadas
                                      // Todo: ya que este método actualiza la baseurl en función del team, por eso no funcionaban los enlaces, porque no se estaba utilizando en esos casos
                                      // todo: seguramente NO porque el resto de la app funcionaba correctamente pero CONFIRMAR!!
    } else { // si url es null o "", recuperar valor por defecto
      this.resetBaseUrlAPI();
    }
  }

  // Se usa cuando user hace logout, para recuperar el valor por defecto de URL base.
  public resetBaseUrlAPI() {
    console.log('baseurl reset');
    
    this.baseUrlAPIWithVersion = this.baseUrlDefault + this.apiVersion;
    this.baseUrlAPINoVersion = this.baseUrlDefault;
    console.log('baseUrl with version',this.baseUrlAPIWithVersion);
    console.log('baseUrl no version',this.baseUrlAPINoVersion);
    
  }

  private urlAPIGeneratorV1(str: string) : string {
    return (this.isProxy) ? `${this.proxy}api/v1/${str}` : `${this.baseUrlAPIWithVersion}${str}`;
  }

  // FIREBASE CHAT
  getFirebaseUid() {
    return this.tokenRequest('GET', null, 'firebase/data');
  }

  getFirebaseUidOtherUser(idUser: any) {
    return this.tokenRequest('GET', null, 'firebaseuid/user/' + idUser);
  }

  /*setFirebaseUid(datos: any) {
    return this.tokenRequest('POST', null, {firebase_uid: datos}, (this.isProxy) ? this.proxy + "api/v1/firebaseuid" : this.baseUrl + "firebaseuid");
  }*/

  obtenerDetailUserFirebase(idFirebase) {
    return this.tokenRequest('GET', null, 'firebaseuid/user/info/' + idFirebase);
  }

  /**
   * Devuelve info básica del array de usuarios Firebase.
   * @param {*} datos Array de UIDs de usuarios Firebase.
   * @returns Array con info de cada usuario: [{ name, identifier, image_resize }, ... ].
   */
  obtenerInfoUsersChatArray(datos: any) {
    return this.tokenRequest('POST', { firebase_uids: datos }, 'firebaseuid/user/group-info');
  }

  createConverInd(datos: any) {
    return this.tokenRequest('POST', { firebase_uid: datos }, 'firebase/create/conversation');
  }

  sendPushBuzz(idFirebase: any) {
    return this.tokenRequest('GET', null, 'chat/sendBuzz/' + idFirebase);
  }

  resetNotfications() {
    return this.tokenRequest('GET', null, '/notifications?reveart=1');
  }

  getNotificationsRead(){
    return this.tokenRequest('GET', null, '/notifications-not-read')
  }

  sendNotificationChat(firebaseId, online){
    return this.tokenRequest('GET', null, `chat/sendNewChatMessage/${firebaseId}?online=${online}`)
  }

  getConfigPush() {
    return this.tokenRequest('GET', null, 'configuration/push');
  }

  obtainListBySkill(id: number) {
    return this.tokenRequest('GET', null, 'team/search/skill/' + id);
  }

  checkTermOfUse() {
    return this.tokenRequestTryCacheGET('checktermsofuse');
  }

  loadConfigMock() {
    return this.tokenRequest('GET', null, 'assets/conf.json');
  }

  loadConfig() {
    return this.tokenRequest('GET', null, 'settings');
  }

  // Idiomas
  getLanguages() {
    return this.tokenRequestTryCacheGET('languages');
  }

  getLevelLanguages() {
    return this.tokenRequestTryCacheGET('languages/levels');
  }

  checkFirstLogin() {
    return this.tokenRequest('GET', null, 'user/firstLoginToday');
  }

  obtenerPerfil() {
    return this.tokenRequest('GET', null, 'user');
  }

  obtenerProfilePhoto(idUser) {
    return this.tokenRequest('GET', null, 'profile/photo/' + idUser);
  }

  obtenerEvents() {
    return this.tokenRequestTryCacheGET('events');
  }

  obtenerEventsPage(page: number) {
    return this.tokenRequestTryCacheGET(`events?page=${page}`);
  }

  obtenerDirectoryLite() {
    return this.tokenRequest('GET', null, 'team/directory-lite');
  }

  obtenerAdvantages() {
    return this.tokenRequestTryCacheGET('advantages');
  }

  obtenerAdvantagesPage(page: number) {
    return this.tokenRequestTryCacheGET(`advantages?page=${page}`);
  }

  obtenerCoursesPage(page: number) {
    return this.tokenRequestTryCacheGET(`courses?page=${page}`);
  }

  obtenerCoursesJoinedPage() {
    return this.tokenRequest('GET', null, 'courses/joined');
  }

  obtenerCourseDetail(idCourse: number) {
    return this.tokenRequestTryCacheGET(`courses/detail/${idCourse}`);
  }

  obtenerSuggestions() {
    return this.tokenRequest('GET', null, 'suggestions');
  }

  obtenerSuggestionsPage(page: number) {
    return this.tokenRequest('GET', null, 'suggestions?page=' + page);
  }

  obtenerVersionMinima(appCode) {
    return this.tokenRequest('GET', null, 'versions/' + appCode);
  }

  obtainOnboarding() {
    return this.tokenRequest('GET', null, 'onboarding');
  }

  obtainPolls() {
    return this.tokenRequest('GET', null, 'polls');
  }

  obtenerFeed() {
    return this.tokenRequest('GET', null, 'news');
  }

  obtenerFeeds(page: number, filter?: any, id?) {
    // Todo: pendiente de recibir filtros desde home
    if(id != ''){
      return this.tokenRequest('GET', null, 'news?page=' + page + '&filter=' + filter + '&filter_news_id=' + id);
    }else{
      return this.tokenRequest('GET', null, 'news?page=' + page + '&filter=' + filter);
    }
    
  }

  obtenerNewsDetail(idPost: number) {
    return this.tokenRequest('GET', null, 'news/detail/' + idPost);
  }

  obtenerNewsFilters() { // for news filtering and posting
    return this.tokenRequest('GET', null, 'news/filters-news');
  }

  obtainComments(number: number) {
    return this.tokenRequest('GET', null, `news/${number}/comments`);
  }

  obtainCommentsPage(number: number, page: number) {
    return this.tokenRequest('GET', null, `news/${number}/comments?page=${page}`);
  }

  getCareerPlan() {
    return this.tokenRequestTryCacheGET('user/careerplan');
  }

  getPrivateFiles() {
    return this.tokenRequestTryCacheGET('user/privateFiles');
  }

  obtainTimeOffTypes() {
    return this.tokenRequestTryCacheGET('typetimeoffs');
  }

  obtainMyTimeOff() {
    return this.tokenRequest('GET', null, 'timeoffs');
  }

  obtainMyHolidays() {
    return this.tokenRequest('GET', null, 'timeoffdays');
  }

  obtainOwnerTimeOffs(filter) {
    let filterAux = filter;
    if (filterAux !== '') filterAux = '/' + filterAux;
    return this.tokenRequest('GET', null, ('owner/timeoffs' + filterAux));
  }

  obtainScoreGlobalLite() {
    return this.tokenRequest('GET', null, 'team/directory/score-lite/global');
  }

  obtainScoreGlobalLitePage(page: number) {
    return this.tokenRequest('GET', null, `team/directory/score-lite/global?page=${page}`);
  }

  obtainScoreMonthLite() {
    return this.tokenRequest('GET', null, 'team/directory/score-lite/monthly');
  }

  obtainScoreMonthLitePage(page: number) {
    return this.tokenRequest('GET', null, `team/directory/score-lite/monthly?page=${page}`);
  }

  obtainScoreDepartments() {
    return this.tokenRequestTryCacheGET('team/directory/score/department');
  }

  obtainScoreDepartmentPage(page: number) {
    return this.tokenRequestTryCacheGET(`team/directory/score/department?page=${page}`);
  }

  suggestionsCategory() {
    return this.tokenRequestTryCacheGET('suggestions/categories');
  }

  obtainImportantFiles() {
    return this.tokenRequestTryCacheGET('importantfiles');
  }

  getNotifications() {
    return this.tokenRequest('GET', null, 'notifications');
  }

  getScore() {
    return this.tokenRequest('GET', null, 'points/getMyPoints/v2');
  }

  getScoreOriginal() {
    return this.tokenRequest('GET', null, 'points/getMyPoints');
  }

  getListPuntuableActions() {
    return this.tokenRequestTryCacheGET('points/puntuableActions');
  }

  obtenerDirectoryLitePage(page: number) {
    return this.tokenRequest('GET', null, 'team/directory-lite?page=' + page);
  }

  obtenerDetailUser(id: number) {
    return this.tokenRequestTryCacheGET(`team/user/detail/${id}`);
  }

  obtenerStatusList() {
    return this.tokenRequestTryCacheGET('user/default-status');
  }

  // Habilidades
  getCategoriesSkills() {
    return this.tokenRequestTryCacheGET('skills/categories');
  }

  getSkills() {
    return this.tokenRequestTryCacheGET('skills');
  }

  // Cursos de formación
  getTrainingCourses() {
    return this.tokenRequestTryCacheGET('trainingcourses');
  }

  // Certificaciones
  getCertifications() {
    return this.tokenRequestTryCacheGET('certifications');
  }

  // Títulos académicos
  getAcademicTitle() {
    return this.tokenRequestTryCacheGET('academictitles');
  }

  // Get expenses
  getExpenses() {
    return this.tokenRequest('GET', null, 'expenses');
  }

  // Get expenses settings
  // getExpenseSettings() {
  //   return this.tokenRequestTryCacheGET('expenseSettings');
  // }
  getExpenseSettings(data?) {
    return this.tokenRequest('GET', null, 'expenseSettings?key=' + data);
  }

  getWorkDayRecordToday() {
    return this.tokenRequest('GET', null, 'workdayrecord/getRecordsToday');
  }

  getReservationsCalendar(date: string) {
    return this.tokenRequest('GET', null, 'reservationsCalendar?date=' + date);
  }

  getMyReservations() {
    return this.tokenRequest('GET', null, 'getReservations');
  }

  getRoomsCalendar() {
    return this.tokenRequestTryCacheGET('roomsCalendar');
  }

  getSettingsDinningRooms() {
    return this.tokenRequest('GET', null, 'settingsTablet');
  }

  registerDevice(body: any) {
    return this.tokenRequest('POST', body, 'user/device');
  }

  logoutDevice(body: any) {
    return this.tokenRequest('POST', body, 'user/logoutDevice');
  }

  deletePoll(body: any) {
    return this.tokenRequest('POST', body, 'user/deletePoll');
  }

  udateConfigPush(body: any) {
    return this.tokenRequest('POST', body, 'configuration/push');
  }

  acceptTerms(datos: any) {
    return this.tokenRequest('POST', datos, 'accepttermsofuse');
  }

  getTeamUrl(datos: any) {
    return this.noTokenRequest('POST', datos, 'teamurl');
  }

  login(datos: any) {
    return this.noTokenRequest('POSTLOGIN', datos, 'login'); // TODO revisar
  }

  addProfilePhoto(datos: any) {
    return this.tokenRequest('POST', datos, 'profile/photo');
  }

  addSuggestions(datos: any) {
    return this.tokenRequest('POST', datos, 'suggestions/add');
  }

  updateOnboarding(datos) {
    return this.tokenRequest('POST', datos, 'onboarding');
  }

  postNewsFilters(datos: any) {
    return this.tokenRequest('POST', datos, 'news/filters-news');
  }

  postLikePost(idNew: number) {
    return this.tokenRequest('POST', null, `news/${idNew}/like`);
  }

  postCreatePost(body: any) {
    return this.tokenRequest('POST', body, 'news');
  }

  postNew(body:any,id: any,) {
    if(id == undefined){
      return this.tokenRequest('POST', body, 'news');

    }else{
      if( id !== null){
        return this.tokenRequest('POST', body, `news/${id}/update`); 
      }
    }

    
  
  }

  postStatusTimeOff(datos) { // id, status, reason
    return this.tokenRequest('POST', datos, 'owner/updateTimeOff');
  }

  joinCourse(course: any) {
    return this.tokenRequest('POST', course, 'course/join');
  }

  givePoints(user: any, body: any) {
    return this.tokenRequest('POST', body, `points/givePoints/${user}`);
  }

  addComment(id: number, body: any) {
    return this.tokenRequest('POST', body, `news/${id}/comment`);
  }

  updateUserStatus(body: any) {
    return this.tokenRequest('POST', body, 'user/status');
  }

  updateSkills(body: any) {
    return this.tokenRequest('POST', body, 'skill/update');
  }

  removeSkills(body: any) {
    return this.tokenRequest('POST', body, 'skill/remove');
  }

  postTrainingCourses(body: any) {
    return this.tokenRequest('POST', body, 'trainingcourses/add');
  }

  updateTrainingCourses(body: any) {
    return this.tokenRequest('POST', body, 'trainingcourses/update');
  }

  deleteTrainingCourses(body: any) {
    return this.tokenRequest('POST', body, 'trainingcourses/remove');
  }

  addCertification(body: any) {
    return this.tokenRequest('POST', body, 'certification/add');
  }

  updateCertification(body: any) {
    return this.tokenRequest('POST', body, 'certification/update');
  }

  removeCertification(body: any) {
    return this.tokenRequest('POST', body, 'certification/remove');
  }

  postLanguage(body: any) {
    return this.tokenRequest('POST', body, 'language/add');
  }

  updateLanguage(body: any) {
    return this.tokenRequest('POST', body, 'language/update');
  }

  deleteLanguage(body: any) {
    return this.tokenRequest('POST', body, 'language/remove');
  }

  addAcademicTitles(body: any) {
    return this.tokenRequest('POST', body, 'academictitles/add');
  }

  deleteAcademicTitles(body: any) {
    return this.tokenRequest('POST', body, 'academictitles/remove');
  }

  updateAcademicTitles(body: any) {
    return this.tokenRequest('POST', body, 'academictitles/update');
  }

  // Experiencias laborales previas
  addMyProfessionalExperience(body: any) {
    return this.tokenRequest('POST', body, 'professionalExperience');
  }
  // actualizar Experiencia laboral
  editMyProfessionalExperience(body: any, id: any) {
    return this.tokenRequest('POST', body, `professionalExperience/${id}/update`);
  }

  getMyProfessionalExperiences() {
    return this.tokenRequest('GET', null, 'getProfessionalExperiences');
  }

  deleteMyProfessionalExperience(body: any) {
    return this.tokenRequest('POST', body, 'professionalExperience/delete');
  }

  searchDirectoryRanking(body: any) {
    return this.tokenRequest('POST', body, 'team/search');
  }

  searchDirectory(body: any) {
    return this.tokenRequestOld('POST', body, (this.isProxy) ? this.proxy + 'api/v2/team/search' : this.baseUrlAPINoVersion + '/api/v2/team/search'); // TODO: revisar
  }

  postTimeOffRequest(datos: any) {
    return this.tokenRequest('POST', datos, 'timeoffs-v2');
  }

  postSkills(body: any) {
    return this.tokenRequest('POST', body, 'skill/add');
  }

  // Add expenses
  postAddExpense(body: any) {
    return this.tokenRequest('POST', body, 'expenses');
  }

  // Update expenses
  postUpdateExpense(body: any) {
    return this.tokenRequest('POST', body, `expenses/${body.id}`);
  }

  // Create record day
  postCreateRecord(body: any) {
    return this.tokenRequest('POST', body, 'workdayrecord/store');
  }

  // Create record day
  postLazyworkRecord(body: any) {
    return this.tokenRequest('POST', body, 'workdayrecord/store/lazy');
  }

  // Get record by user
  getLastRecordsByUser(urlData: any) {
    const path = this.appendUrlDataIfExist('workdayrecord/getLastRecords', urlData);
    return this.tokenRequest('GET', null, path); // TODO: revisar param
  }

  // Get files nominas
  getFilesAlfresco(urlData?) {
    const path = this.appendUrlDataIfExist('modules/alfresco/files', urlData);
    return this.tokenRequest('GET', null, path);
  }

  // Get file nominas
  getFileAlfresco(nodeRef: string) {
    return this.tokenRequest('GET', null, 'modules/alfresco/file?nodeRef=' + nodeRef);
  }

  deleteTimeoff(idTimeoff) {
    return this.tokenRequest('DELETE', null, `timeoff/${idTimeoff}`);
  }
  addAttachProof(id: number, datos) {
    return this.tokenRequest('POST', datos, `timeoffs/${id}/attach-proof`);
  }

  deleteNewPost(id: number) {
    return this.tokenRequest('DELETE', null, `news/delete/${id}`);
  }

  deleteMyExpense(id: number) {
    return this.tokenRequest('DELETE', null, `expenses/${id}`);
  }

  deleteMyExpenseFile(id: number) {
    return this.tokenRequest('DELETE', null, `expenses/file/${id}`);
  }

  // Api's diner colevisa
  getDefaultMenuType() {
    return this.tokenRequest('GET', null, 'diner/user/defaultMenuType');
  }

  getUserAllergens() {
    return this.tokenRequest('GET', null, 'diner/user/allergens');
  }

  postDailyMenus(body: any) {
    return this.tokenRequest('POST', body, 'diner/user/dailyMenus');
  }

  postDinerUserCalendar(body: any) {
    return this.tokenRequest('POST', body, 'diner/user/calendar');
  }

  postReedemCancelOrder(body: any, idMenu, type: string) { // TODO: mejorar esto
    const sufix = (type === 'exchange') ? 'generateQr' : 'cancelOrder';
    return this.tokenRequest('POST', body, `diner/user/menus/${idMenu}/${sufix}`);
  }

  postMenusHistory(body: any) {
    return this.tokenRequest('POST', body, 'diner/user/history');
  }

  postUpdateUserAllergens(body: any, idAllergen) {
    return this.tokenRequest('POST', body, `diner/user/allergens/${idAllergen}`);
  }

  postUpdateDefaultMenuType(idMenuType) {
    return this.tokenRequest('POST', null, `diner/user/defaultMenu/${idMenuType}`);
  }

  postMenuOrder(body: any, idMenu) {
    return this.tokenRequest('POST', body, `diner/user/menus/${idMenu}/order`);
  }

  createRoomReservation(datos: any) {
    return this.tokenRequest('POST', datos, 'createReservation');
  }

  deleteRoomReservation(datos: any) {
    return this.tokenRequest('POST', datos, 'deleteReservation');
  }

  updateRoomReservation(datos: any) {
    return this.tokenRequest('POST', datos, 'updateReservation');
  }
  getMyRequestWorkday() {
    return this.tokenRequest('GET', null, 'workdayrecord/modifications/getMyRequests');
  }

  // Devuelve los días festivos del centro de trabajo del usuario.
  getHolidays(year: string) {
    return this.tokenRequest('GET', null, `calendars/days/${year}`);
  }
  // Devuelve el mensaje anclado en home
  getPinnedMessage() {
    return this.tokenRequestTryCacheGET('PinnedMessage');
  }
  // recupera las incidencias de fichaje
  getIncidences() {
    return this.tokenRequest('GET', null, 'incidences');
  }
  // modificación de incidencia de fichaje impar
  postmodificationStoreBreak(body: any) {
    return this.tokenRequest('POST', body, 'workdayrecord/modifications/store/break');
  }
  // calcula tiempo efectivo de trabajo en modificación de fichaje impar
  getEffectiveTime(data) {
    return this.tokenRequest('POST', data, 'workdayrecord/modifications/break/effective_time');
  }
  // Modificación e incidencias de fichajes lazy
  postmodificationrequest(body: any) {
    return this.tokenRequest('POST', body, 'workdayrecord/modifications/store/lazy');
  }
  // Solicitud de borrado de un registro horario
  postDeleteRegister(body: any) {
    return this.tokenRequest('POST', body, 'workdayrecord/modifications/store_delete');
  }
  // Verificar si un fichaje tiene incidencia
  getHasIncidence(shift) {
    return this.tokenRequest('GET', null, `workdayrecord/${shift}/hasWorkdayRecordLogIncidence`);
  }
  // modificar un timeoff ya existente cuando viene de incidencia
  postUpdateTimeoffIncidence(id: any, data: any) {
    return this.tokenRequest('POST', data, `timeoffs/${id}/updateFromIncidence`);
  }
  // Solicitar una cancelación de una solucitud de ausencia aprobada
  postCancelTimeOffApproved(data: any) {
    return this.tokenRequest('POST', data, 'timeoffcancellation');
  }
  // cambiar work day a auto
  postWorkingDayAuto(data: any) {
    return this.tokenRequest('POST', data, 'workday-auto');
  }
  // cambiar work day a manual
  postWorkingDayManual() {
    return this.tokenRequest('POST', null, 'workday-manual');
  }
  // Llamada auxiliar para solicitar datos de un fichaje y discriminar si es lazy o interactivo
  getRecordFromShift(shift) {
    return this.tokenRequest('GET', null, `workdayrecord/${shift}/recordsFromShift`);
  }
  // recupera las solicitudes de cancelacion de ausencia para el manager
  getCancellations() {
    return this.tokenRequest('GET', null, 'owner/timeoffcancellations');
  }
  // Aprobar o rechazar solicitud de cancelacion por el manager
  postCancelTimeOffApprovedOwner(data: any) {
    return this.tokenRequest('POST', data, 'owner/timeoffcancellation/updateStatus');
  }
  // Recuperar turno de trabajo para descripción en Covid-MiOficina
  postShiftSchedules(data: any) {
    return this.tokenRequest('POST', data, 'shift-schedules');
  }
  // Recuperamos las vacantes existente
  getVacancies() {
    return this.tokenRequestTryCacheGET('vacancies');
  }
  // Recuperar CV en formato .docx para descargar
  postDownloadCV(data: any) {
    return this.tokenRequest('POST', data, 'user/downloadCvAlfatec'); // TODO: naming...
  }
  // Recuperamos contadores de horas de registro del user
  getCounters() {
    return this.tokenRequest('GET', null, 'workdayrecord/getCounters');
  }
  // Leemos código QR en entrada oficina, para saber si user tiene sintomas Covid o no.
  getReadQr(data) {
    return this.tokenRequest('POST', data, 'readQr');
  }
  // comprobamos que si el usuario ya ha realizado una entrada mediante el qr
  getLastQR(stringQr) {
    return this.tokenRequest('GET', null, `getInfoLastQrToday?string=${stringQr}`); // TODO: revisar format
  }
  // Recuperamos el total de días disfrutados y pendientes de todos los tipos de ausencia
  getCounterTimeoff() {
    return this.tokenRequest('GET', null, 'timeoff-counters');
  }
  // Recuperamos si es auto en la jornada
  getIsAuto() {
    return this.tokenRequest('GET', null, 'workday-auto/is-auto');
  }
  // OBTENEMOS LA INFO DE LAS DIETAS
  getExpensesinfo() {
    return this.tokenRequest('GET', null, 'expenseOptions');
  }
  getRecordAuto() {
    return this.tokenRequest('GET', null, 'workday-auto');
  }
  // Recuperar cálculo de horas y dias para un timeoff
  getTimeDayTimeoff(data: any) {
    return this.tokenRequest('POST', data, 'timeoffs/calculate-time');
  }
  getOnboardingComplete(){
    return this.tokenRequest('GET', null, 'user/filled-profile');
  }
  getShowOnboarding(place){
    return this.tokenRequest('GET', null, `user/show-onboarding-info?place=${place}`);
  }

  private appendUrlDataIfExist(path, urlData) {
    let ret = path;
    ret += ((urlData) ? this.getUrlEncodedParams(urlData) : '');
    return ret;
  }

  private getUrlEncodedParams(data: any) {
    let urlSearchParams = new HttpParams();

    Object.keys(data).forEach(key => {
      urlSearchParams = urlSearchParams.append(key, data[key]);
    });
    return '?' + urlSearchParams.toString();
  }

  /**
   * Para pasar por la cache antes de hacer la request GET.
   * Funciona con promises<any>; no hace falta observable.
   *
   * Usa los mismos params que tokenRequest()
   * @param path url de la petición
   */
  private tokenRequestTryCacheGET(path: string): Promise<any> {
    return this.cache.getOrSetItem(path, () => this.tokenRequest('GET', null, path));
  }

  // nuevo método. Gestiona internamente el cambio de path para Proxy
  private tokenRequest(method: string, data: any, path: string) {
    return this.tokenRequestOld(method, data, this.urlAPIGeneratorV1(path));
  }

  private tokenRequestOld(method: string, data: any, path: string): Promise<any> {
    return this.localStorage.getToken().then(token => {
      if (this.connectivityService.isOnline()) {
        if (token) {
          const lang:any = this.getLanguage();
          const headersAuth = new HttpHeaders({
            Accept: 'application/json',
            Authorization: 'Bearer ' + token,
            'Accept-Language': lang,
          });
          return this.request(method, path, data, { headers: headersAuth });
        } else {
          this.clearLocalStorageAndGoLogin();
        }
      } else {
        this.messagePresenter.presentToast(this.translate.instant('noconn'), 2000, 'bottom');
        return Promise.reject({ customError: 'noconn' });
      }
    });
  }

  private noTokenRequest(method: string, data: any, path: string): Promise<any> {
    const pathUpdated = this.urlAPIGeneratorV1(path);
    if (this.connectivityService.isOnline()) {
      const lang:any = this.getLanguage();
      const headersAuth = new HttpHeaders({
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Accept-Language': lang,
      });
      return this.request(method, pathUpdated, data, { headers: headersAuth });
    } else {
      this.messagePresenter.presentToast(this.translate.instant('noconn'), 2000, 'bottom');
      // TODO: esta línea está mal. Si no hay token ni internet... mejor navegar a la pantalla de login, no a pantalla "office"...
      this.app.getRootNavs()[0].setRoot('MyOfficePage');
      return Promise.reject({ customError: 'noconn' });
    }
  }

  private getLanguage() {
    if (this.translate.currentLang === 'es' || this.translate.currentLang === 'ca') {
      return 'es';
    } else {
      return 'en';
    }
  }

  private request(method: string, path: string, data: any, headers: any): Promise<any> {
    switch (method) {
      case 'GET':
        return this.getRequest(path, data, headers);
      case 'POST':
      case 'POSTLOGIN':
        return this.postRequest(path, data, headers, method);
      case 'DELETE':
        return this.deleteRequest(path, data, headers);
    }

    return null; // impossible case
  }

  private getRequest(path: string, data: any, headers: any) {
    return this.http.get(path, headers)
      .toPromise().then(response => {
        return response;
      })
      .catch(error => {
        console.log('Error en get' + JSON.stringify(error));
        return this.handleError(error);
      });
  }

  private postRequest(path: string, data: any, headers: any, login) {
    return this.http.post(path, (data) ? data : {}, headers)
      .toPromise().then(response => {
        return response;
      })
      .catch(error => {
        if (login === 'POSTLOGIN') { // TODO: revisar
          return Promise.reject(error);
        } else {
          return this.handleError(error);
        }
      });
  }

  private deleteRequest(path: string, data: any, headers: any) {
    return this.http.delete(path, headers)
      .toPromise().then(response => {
        return response;
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  private handleError(error: any): Promise<any> {
    this.manageErrors(error);
    return Promise.reject(error);
  }

  public manageErrors(error: any) {
    if (this.connectivityService.isOnline()) {
      if (error.status) {
        switch (error.status) {
          case '401': // 401 Unauthorized
          case '402': // 402 Payment Required
          case 401: // 401 Unauthorized
            this.clearLocalStorageAndGoLogin();
            break;
          case '400': // 400 Bad Request Error
          case '403': // 403 Forbidden
            this.messagePresenter.presentToast(error.error.message, 2000, 'bottom');
            break;
          case '422': // 422 Unprocessable Entity
            this.handlerErrorUnprocessableEntity(error);
            break;
          case '500': // 500 Internal Server Error
            this.messagePresenter.presentToast(this.translate.instant('noserver'), 2000, 'bottom');
            break;
          case '429': // 429 Too Many Requests
            this.messagePresenter.presentLoadingCustom('crescent', this.translate.instant('wait'), 35000);
            break;
          // TODO: revisar, falta caso default?
        }
      }
    } else {
      // No hay internet
      // TODO: revisar, ¿mostrar mensaje en los demás casos?
    }
  }

  private handlerErrorUnprocessableEntity(error) {
    if (error.error.errors) {
      const field = Object.keys(error.error.errors)[0];
      this.messagePresenter.presentToast(error.error.errors[field], 2000, 'bottom');
    } else {
      if (error.error.message && this.ftFlags.DiningRooms) {
        const modal = this.modalCtrl.create('PopUpSolicitud', { message: error.error.message });
        modal.present();
      }
    }
  }

  /**
   * Borra la cache.
   * Returns promise.
   */
  private clearCache(): Promise<any> {
    return this.cache.clearAll();
  }

  /**
   * Borra la cache, el localstorage, desconecta de firebase y
   * navega a la pantalla Organization o Login (navegación según feature flags).
   */
  public clearLocalStorageAndGoLogin() {
    console.log('clear');
    
    this.clearCache().then(res => {
      console.log('clearcache');

      this.localStorage.clearKeys().then(result => {
        console.log('clearkeys');

        firebase.auth().signOut().then(user => {
          console.log('signout');

          this.localStorage.getUrlBaseAPI().then(url => {
            console.log('geturlbase');

            this.resetBaseUrlAPI();

            let page = 'Organization';
            let domain = 'null';

            /* if (!this.ftFlags.hasOrganizationPage()) {
              page = 'Organization';
              domain = (this.ftFlags.SoyColevisa) ? 'colevisa' : 'startupv';
            } */
            this.app.getRootNavs()[0].setRoot(page);
            this.app.goBack();
          });
        });
      });
    });
  }

  obtainProjects(){
    return this.tokenRequest('GET', null, 'expenseProjects?filter=');
  }
  
}



// WEBPACK FOOTER //
// ./src/services/api.ts